export { default } from './FormSwitch';
